import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

const parseJsonFallback = text => {
    if (isEmpty(text)) {
        return {
            valid: true,
            value: null
        };
    }

    try {
        return {
            valid: true,
            value: JSON.parse(text)
        };
    } catch (e) {
        return {
            valid: false,
            value: null
        };
    }
};

const parseJsonFallbackValue = text => parseJsonFallback(text).value;

const stringifyJsonFallbackValue = value => {
    try {
        return value ? JSON.stringify(value, null, 2) : '';
    } catch (e) {
        return '';
    }
};

const isPlainJsonObject = value => Object.prototype.toString.call(value) === '[object Object]';

const isBlankOrJsonObject = (value, text) => isEmpty(text) || isPlainJsonObject(value);

const syncJsonFallbackValue = ({
                                   text,
                                   currentValue,
                                   annotations = [],
                                   requireObject = false,
                                   isValidValue = null,
                                   onValidJson
                               }) => {
    const parsed = parseJsonFallback(text);
    const newValue = parsed.value;
    const valid = parsed.valid && isEmpty(annotations) &&
        (!requireObject || isPlainJsonObject(newValue)) &&
        (!isValidValue || isValidValue(newValue, text));
    if (!valid) {
        return {
            valid: false,
            changed: false,
            value: newValue
        };
    }

    const changed = !isEqual(currentValue, newValue);
    if (changed) {
        onValidJson(newValue);
    }

    return {
        valid: true,
        changed,
        value: newValue
    };
};

export {
    isBlankOrJsonObject,
    isPlainJsonObject,
    parseJsonFallbackValue,
    stringifyJsonFallbackValue,
    syncJsonFallbackValue
};
